export const ADMIN_CREATE_USER = 'adminCreateUser'
export const ADMIN_CHANGE_PASSWORD = 'adminChangePassword'
